import { X } from "lucide-react";

export default function MobileMenu({open,setOpen}){

return(

<div
className={`fixed inset-0 z-50 transition

${open
?"translate-x-0"
:"translate-x-full"}

`}
>

<div
className="absolute inset-0 bg-black/40"
onClick={()=>setOpen(false)}
/>

<div className="absolute right-0 top-0 h-full w-72 bg-white p-8">

<div className="flex justify-end">

<button onClick={()=>setOpen(false)}>

<X/>

</button>

</div>

<nav className="flex flex-col gap-8 mt-12 text-lg">

<a href="/">Shop</a>

<a href="/">Books</a>

<a href="/">Coffee</a>

<a href="/">Greens</a>

<a href="/">Accessories</a>

<a href="/">Journal</a>

<a href="/">About</a>

</nav>

</div>

</div>

)

}